<template>
  <div :class="$style.container">
    <div
      v-for="item in tabs"
      :key="item.id"
      :class="[$style.tab, active === item.id && $style.tabActive]"
    >
      <button :class="$style.button" @click="onChange(item.id)">{{ item.name }}</button>
    </div>
  </div>

</template>

<script>
export default {
  name:  "TabsHeader",
  props: ['tabs', 'onChange', 'active'],
};
</script>

<style lang="scss" module>
.container {
  display: flex;
}

.tab {
  border-bottom: 2px solid transparent;
  @include anim();
}

.tabActive {
  border-color: color(primary);

  .button {
    color: color(primary);
  }
}

.button {
  border: 0;
  background: transparent;
  padding: 10px;
  cursor: pointer;
  @include anim();

  &:hover {
    color: color(primary);
  }
}
</style>
